import React, { cloneElement, isValidElement, Children } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { fieldType } from '#/user/formstackConfig';
import * as Styled from './styled';

function FieldWrapper({ fieldConfig, labelIntlId, children }) {
  // apply fieldConfig props to child element
  const childrenWithFieldConfig = Children.map(children, c =>
    isValidElement(c) ? cloneElement(c, fieldConfig) : c
  );

  return (
    <>
      <Styled.FeedbackFormFieldLabel>
        <FormattedMessage id={`feedback.${labelIntlId}`} />
        {fieldConfig.required ? ' *' : ''}
      </Styled.FeedbackFormFieldLabel>
      {childrenWithFieldConfig}
    </>
  );
}

FieldWrapper.propTypes = {
  fieldConfig: fieldType.isRequired,
  labelIntlId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FieldWrapper;
